import imageToTextIcon from '../../assets/image_to_text.png';
import voiceTypingIcon from '../../assets/voice_typing.png';
import dictionaryIcon from '../../assets/dictionary.png';
import quizIcon from '../../assets/quiz.png';
import translateIcon from '../../assets/translate_icon.png';
import aiCommandIcon from '../../assets/aicommand.png'

const products = [
    {
        img: voiceTypingIcon,
        title: 'Voice Typing',
        description: 'Dictate into any website, use custom commands, and write faster without switching tools.',
        author: '@fxnoob',
        rows: 2,
        cols: 3,
        featured: true,
        web: 'https://voicetyping.xyz/',
        chrome: 'https://chrome.google.com/webstore/detail/voice-typing/hmpihaioaacpehkghnkmnmgmihalkmdf'
    },
    {
        img: imageToTextIcon,
        title: 'Image to Text (OCR)',
        description: 'Extract text from screenshots, images, documents, and scanned content in the browser.',
        author: '@fxnoob',
        rows: 2,
        cols: 3,
        featured: true,
        web: 'https://imagetext.xyz/',
        chrome: 'https://chrome.google.com/webstore/detail/image-to-text-ocr/jgjlejdhmfpimggbicpffmpbnalcnhoo',
        edge: 'https://microsoftedge.microsoft.com/addons/detail/image-to-text-ocr/icgbomdceijejlokdmjpmgkojiliphma',
        opera: 'https://addons.opera.com/en/extensions/details/image-to-text-ocr/'
    },
    {
        img: aiCommandIcon,
        title: 'AI Command',
        description: 'Run quick AI prompts and writing commands from your browser workflow.',
        author: '@fxnoob',
        isNew: true,
        rows: 3,
        cols: 3,
        featured: true,
        chrome: 'https://chrome.google.com/webstore/detail/ai-command/iinfmfmneepgdhlfeibcdmmdaflfjaic',
        web: 'https://aicommand.xyz/',
    },
    {
        img: quizIcon,
        title: 'CBSE & NCERT quiz',
        description: 'Practice school quiz questions with browser and Android access.',
        author: '@fxnoob',
        isNew: true,
        rows: 3,
        cols: 3,
        featured: true,
        chrome: 'https://chrome.google.com/webstore/detail/cbse-ncert-quiz/fhjhphocpoappbigjhcfeffndhjgikch',
        web: 'https://quizs.in/',
        android: 'https://play.google.com/store/apps/details?id=com.quizs.app',
    },
    {
        img: translateIcon,
        title: 'Translate',
        description: 'Translate selected text and web content quickly while browsing.',
        author: '@fxnoob',
        rows: 2,
        cols: 3,
        featured: true,
        chrome: 'https://chrome.google.com/webstore/detail/translate/pobhnbdhbklfjhlhpmoegnneonlnkbpo',
        edge: 'https://microsoftedge.microsoft.com/addons/detail/translate/fgdbpaadcpabolagoajbhapbhbmpolcm'
    },
    {
        img: dictionaryIcon,
        title: 'Dictionary Browser Extension',
        description: 'Look up meanings from Oxford, Webster, Wikipedia, and web dictionaries in one place.',
        author: '@fxnoob',
        rows: 2,
        cols: 3,
        featured: true,
        chrome: 'https://chrome.google.com/webstore/detail/dictionary-oxford-webster/pbknajakomimhnnaiddkbddboifjolbf',
        edge: 'https://microsoftedge.microsoft.com/addons/detail/dictionary-oxford-webs/pbcjplaagkgfgihmbcbbmfdadhbekpeb',
        opera: 'https://addons.opera.com/en/extensions/details/dictionary-oxford-webster-and-wikipedia/'
    }
];

export default products;
